// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner-module__spinner___21l7w","spin":"spinner-module__spin___3V_pk","inline":"spinner-module__inline___1EonZ"};